require("./qf/LocalizationForm");
require("./qf/99-predictiveSearch");
require("./qf/99-MobileMenu");

import { CartQf } from './qf/cart';
import { GlobalListeners } from './qf/global_listeners';
// import { PredictiveSearch } from './qf/v3-predictiveSearch';
import { ModalController } from './qf/ModalController';
import { LoadMore } from './qf/loadMore';
// import { QfForm } from './qf/formSubmission';
import { VideoControls } from './qf/VideoControls';
import { OptionSelectors } from './qf/OptionSelectors';
// import { ClientOptionSelectors } from './client/ClientOptionSelectors';
import { SiteHeader } from './qf/SiteHeader';
import { SwiperFadeItems } from './qf/SwiperFadeItems';
import { PredictiveSearch } from './qf/99-predictiveSearch';


window.cart = new CartQf();
window.globalListeners = new GlobalListeners();
window.predictiveSearch = new PredictiveSearch();
window.modalController = new ModalController()
window.LoadMore = LoadMore;
// window.QfForm = QfForm;
window.VideoControls = new VideoControls;
window.OptionSelectors = OptionSelectors;
// window.OptionSelectors = ClientOptionSelectors;
window.SiteHeader = new SiteHeader;
window.SwiperFadeItemsObserver = SwiperFadeItems;
